import { render, staticRenderFns } from "./bidding-notice-detail.vue?vue&type=template&id=72dc37ce&scoped=true&"
import script from "./bidding-notice-detail.vue?vue&type=script&lang=js&"
export * from "./bidding-notice-detail.vue?vue&type=script&lang=js&"
import style0 from "./bidding-notice-detail.vue?vue&type=style&index=0&id=72dc37ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dc37ce",
  null
  
)

export default component.exports